module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4zNyIgaGVpZ2h0PSI5LjAxOCIgdmlld0JveD0iMCAwIDE1LjM3IDkuMDE4Ij4KICA8cGF0aCBpZD0iYXJyb3ctZG93biIgZD0iTTI0MDMuMzIxLDM5OS4zMThjLjIxNS4wNzgsNiw2LDYsNmw2LTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNDAxLjcxOSAtMzk3LjU1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYmFjM2Q0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMi41Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-down.svg
// module id = vjZZ
// module chunks = 3